<template>

    <div class="trade-box-w"
         v-loading="loading"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)"
    >
        <virtual-list :size="40"
                      wclass="gpListClass"
                      rclass="gpTableClass"
                      :headerTags="tags"
                      :onscroll="onscrollIng"
                      :innerWidth="innerWidth"
                      :debounce="1"
                      ref="virtualList"
                      :remain="remains || 0">
            <template v-if="types === 1">
                <gp-item v-for="(item, index) of dataList"
                         class="gpItem"
                         :types="types"
                         :gptags="tags"
                         :gpData="item"
                         :tabId="tabId"
                         :class="{'active': item === choisCode}"
                         :trIndex="index"
                         @openDetail="openDetail()"
                         @setActive="setTrActive($event)"
                         :key="item"/>
            </template>
            <template v-if="types === 2">
                <gp-item v-for="(item, index) of codes"
                         class="gpItem"
                         :types="types"
                         :gptags="tags"
                         :tabId="tabId"
                         :gpData="item"
                         :class="{'active': item === choisCode}"
                         :trIndex="index"
                         @openDetail="openDetail()"
                         @setActive="setTrActive($event)"
                         :key="item"/>
            </template>
        </virtual-list>
    </div>
</template>

<script>

    import TradePageGpItem from './TradePageGpItem'
    import TradePageGpListUpdate from './TradePageGpListUpdate'
    import TradePageGpListScroll from './TradePageGpListScroll'
    import virtualList from '../../component/VirtualList.js'
    export default {
        name: "TradePageGpList",
        props: {
            tags: {
                type: Array,
                required: true
            }, remains: {
                type: Number,
                default: 0
            }, tableHeight: {
                type: String
            }, codes: {
                type: Array,
            }, dataList: {
                type: Array,
            }, showIng: {
                type: Boolean,
                default: false
            },
            types: Number,
            tabId: Number
        },
        components: {'gp-item': TradePageGpItem, 'virtual-list': virtualList},
        created() {
            // 当前版块除了大盘外，只有显示中，才会更新股票信息
            if(this.showIng && this.types === 2) {
                this.callLoading();
                this.updataItemDetails(0, Math.ceil(this.remains * 2), true);
            }

            window.addEventListener('resize', function () {
                setTimeout(function() {
                    this.innerWidth = window.innerWidth;
                }.bind(this), 500);
            }.bind(this))
        },
        watch: {
            /**
             * 监听当前版块的显示状态，显示后，更新行情
             * @param value
             */
            showIng: function (value) {
                if(value && this.types === 2) {
                    this.updataItemDetails(0, Math.ceil(this.remains * 2), !this.init);
                }
            },
            '$store.state.gp_keys_zi': function (value) {
                // 只有当自选股正在显示，才会更新自选股的行情
                if(value.length > 0 && this.types === 2 && +this.$route.params.id === 4) {
                    this.updataItemDetails(0, Math.ceil(this.remains * 2), !this.init);
                }
            },
            '$store.state.now_chois_gp_item': function (value, ov) {
                if(!ov || ov && ov.hasOwnProperty('code') &&
                    value && value.hasOwnProperty('code') &&
                    ov.code !== value.code) {
                    this.getOnlyGp(value.code);
                }
            },
            '$store.state.scroll_to_item': function () {
                if(this.codes && this.showIng) {
                    const nowIndex = this.codes.indexOf(this.choisCode);
                    this.$refs.virtualList.setScrollTop(nowIndex * 40);
                }
            }

        },
        methods: {
            // 获取屏幕中的股票信息
            ...TradePageGpListUpdate,
            /**
             * 激活这个股票
             * @param code
             */
            setTrActive(code) {
                if(this.types === 1) {
                    this.$store.commit('SET_FOUCS_DP', code);
                } else {
                    this.$store.commit('SET_FOUCS_GP', code);
                }
            },
            // 表格滚动更新屏幕中的股票信息
            ...TradePageGpListScroll,
            /**
             * 跳转这个股票的日k线等详情页面
             */
            openDetail() {
                if(this.types === 2) {
                    this.$router.push({path: '/detail/' + this.types});
                }
            },
            callLoading() {
                this.loading = true;
            },
            getOnlyGp(code) {
                this.$api.getGpDetail(code).then(res => {
                    // 把数据扔给vuex处理
                    if(res.data.code === 1) {
                        this.$store.commit('UPDATE_GP_DETAIL', {data: res.data.data});
                    }
                    if(this.showIng) {
                        this.$store.commit('UPDATE_SOCKET_IDS', {code_s: code, t: 'join'});
                    }
                });
            }
        },
        computed: {
            /**
             * 当前选中状态自动和当前激活的股票同步
             */
            choisCode: function() {
                if(this.$store.state.now_chois_gp_item) {
                    return this.$store.state.now_chois_gp_item.code;
                }
                return null;
            },
        },
        data: function () {
            return {
                actived: null,
                scrollStart: 0,
                gpData: this.dataList,
                timer_: null,
                loading: false,
                init: false,
                newStart: 0,
                innerWidth: window.innerWidth
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "TradePageGpList";

</style>
